/** Fence tag -> download extension. Keys must be lowercase. */
export const fileExtensions: Record<string, string> = {
  apache: '.conf',
  bash: '.sh',
  bat: '.bat',
  batch: '.bat',
  bicep: '.bicep',
  c: '.c',
  'c#': '.cs',
  'c++': '.cpp',
  cmake: '.cmake',
  cmd: '.cmd',
  conf: '.conf',
  cpp: '.cpp',
  cs: '.cs',
  csharp: '.cs',
  css: '.css',
  diff: '.diff',
  docker: '.dockerfile',
  dockerfile: '.dockerfile',
  fortran: '.f90',
  go: '.go',
  golang: '.go',
  haskell: '.hs',
  html: '.html',
  ini: '.ini',
  java: '.java',
  javascript: '.js',
  js: '.js',
  json: '.json',
  jsx: '.jsx',
  julia: '.jl',
  kotlin: '.kt',
  kt: '.kt',
  lua: '.lua',
  makefile: '.mk',
  markdown: '.md',
  mathematica: '.nb',
  matlab: '.m',
  md: '.md',
  nginx: '.conf',
  objectivec: '.m',
  'objective-c': '.m',
  patch: '.patch',
  perl: '.pl',
  php: '.php',
  powershell: '.ps1',
  ps1: '.ps1',
  py: '.py',
  python: '.py',
  pwsh: '.ps1',
  r: '.r',
  rb: '.rb',
  ruby: '.rb',
  rust: '.rs',
  rs: '.rs',
  sass: '.scss',
  scala: '.scala',
  scss: '.scss',
  sh: '.sh',
  shell: '.sh',
  sql: '.sql',
  svg: '.svg',
  swift: '.swift',
  toml: '.toml',
  ts: '.ts',
  tsx: '.tsx',
  typescript: '.ts',
  vb: '.vb',
  vba: '.vba',
  vbnet: '.vb',
  vbs: '.vbs',
  vbscript: '.vbs',
  xml: '.xml',
  yaml: '.yaml',
  yml: '.yml',
};
